import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class ApiaryBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.APIARY;
}

export default ApiaryBuildingTileEntity;
